import { render, staticRenderFns } from "./ResultMaterialsCard.vue?vue&type=template&id=7d2abe54&scoped=true&"
import script from "./ResultMaterialsCard.vue?vue&type=script&lang=js&"
export * from "./ResultMaterialsCard.vue?vue&type=script&lang=js&"
import style0 from "./ResultMaterialsCard.vue?vue&type=style&index=0&id=7d2abe54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2abe54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d2abe54')) {
      api.createRecord('7d2abe54', component.options)
    } else {
      api.reload('7d2abe54', component.options)
    }
    module.hot.accept("./ResultMaterialsCard.vue?vue&type=template&id=7d2abe54&scoped=true&", function () {
      api.rerender('7d2abe54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/LowerBar/ResultMaterialsCard.vue"
export default component.exports